'use server'

import { cookies } from 'next/headers'
import { REFRESH_COOKIE, ACCESS_COOKIE } from './constants'
import type { AccessToken, RefreshToken } from './types'
import { addBreadcrumb } from '@sentry/nextjs'

/**
 * Fetch the access and refresh cookies if they exist
 * @returns
 */
export async function getNextCookies(): Promise<{
  access: AccessToken | undefined
  refresh: RefreshToken | undefined
}> {
  const cookiesStore = await cookies()
  const refresh = cookiesStore.get(REFRESH_COOKIE)
  const access = cookiesStore.get(ACCESS_COOKIE)

  addBreadcrumb({
    message: 'Fetching next cookies',
    data: {
      access: access?.value,
      refresh: refresh?.value,
    },
  })

  return {
    access: access ? JSON.parse(access.value) : undefined,
    refresh: refresh ? JSON.parse(refresh.value) : undefined,
  }
}
